import { IServices } from "@netent/origin";
import { PlayUIListenerCreator } from "../../types";

export const onVolumeChangeRequest: PlayUIListenerCreator = (
  services: IServices
) => (volume: number) => {
  services.gameSettings.setSetting({
    id: "volume",
    value: Number(volume.toFixed(2)),
    persistent: services.game.getCurrentPlatform() === "desktop"
  });
};
